<template>
  <div>
    <v-textarea
      v-model="value.descriptionText"
      :label="$t('riskAssessment.advanced.description')"
      auto-grow
      rows="3"
      outlined
      dense
      hide-details
      class="mb-4"
    ></v-textarea>

    <div class="subtitle-2 mb-2">
      {{ $t("riskAssessment.advanced.descriptionPoints") }}
    </div>

    <div v-if="points.length" class="points mb-2">
      <div v-for="(point, idx) in points" :key="idx" class="point">
        <span class="point__number">{{ idx + 1 }}.</span>
        <template v-if="editingIndex === idx">
          <v-text-field
            v-model="editDraft"
            dense
            hide-details
            autofocus
            class="point__input"
            @keydown.enter.prevent="confirmEdit"
            @keydown.esc.prevent="cancelEdit"
          />
          <v-btn
            icon
            small
            color="success"
            :disabled="!editDraft.trim()"
            @click="confirmEdit"
          >
            <v-icon small>mdi-check</v-icon>
          </v-btn>
          <v-btn icon small @click="cancelEdit">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <div class="point__text" @click="startEdit(idx)">{{ point }}</div>
          <v-btn icon small @click="startEdit(idx)">
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            color="error"
            @click="removePoint(idx)"
          >
            <v-icon small>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
      </div>
    </div>

    <div class="d-flex align-center">
      <v-text-field
        ref="newPointInput"
        v-model="newPoint"
        :placeholder="$t('riskAssessment.advanced.newDescriptionPoint')"
        outlined
        dense
        hide-details
        @keydown.enter.prevent="addPoint"
      />
      <v-btn
        color="primary"
        outlined
        class="ml-2"
        height="40"
        :disabled="!newPoint.trim()"
        @click="addPoint"
      >
        {{ $t("riskAssessment.advanced.addDescriptionPoint") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { newRisk } from "./newRisk";

export default {
  name: "risk-assessment-description",
  props: ["value", "config"],
  data: () => ({
    newPoint: "",
    editingIndex: null,
    editDraft: "",
  }),
  computed: {
    points() {
      return this.value.descriptionPoints || [];
    },
  },
  methods: {
    setPoints(next) {
      this.$set(this.value, "descriptionPoints", next);
    },
    syncRiskTitle(index, text, previous) {
      if (!Array.isArray(this.value.risks)) this.$set(this.value, "risks", []);
      const risks = this.value.risks;
      while (risks.length <= index) risks.push(newRisk());
      const current = risks[index].stepTitle || "";
      if (!current || current === previous) {
        this.$set(risks[index], "stepTitle", text);
      }
    },
    addPoint() {
      const text = this.newPoint.trim();
      if (!text) return;
      const index = this.points.length;
      this.setPoints([...this.points, text]);
      this.syncRiskTitle(index, text, "");
      this.newPoint = "";
      this.$nextTick(() => this.$refs.newPointInput.focus());
    },
    startEdit(idx) {
      this.editingIndex = idx;
      this.editDraft = this.points[idx];
    },
    confirmEdit() {
      const text = this.editDraft.trim();
      if (!text) return;
      const previous = this.points[this.editingIndex];
      const next = [...this.points];
      next.splice(this.editingIndex, 1, text);
      this.setPoints(next);
      this.syncRiskTitle(this.editingIndex, text, previous);
      this.cancelEdit();
    },
    cancelEdit() {
      this.editingIndex = null;
      this.editDraft = "";
    },
    removePoint(idx) {
      const next = [...this.points];
      next.splice(idx, 1);
      this.setPoints(next);
      if (this.editingIndex === idx) this.cancelEdit();
      else if (this.editingIndex !== null && this.editingIndex > idx) {
        this.editingIndex -= 1;
      }
    },
  },
};
</script>

<style scoped>
.point {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 4px;
  border-radius: 4px;
}
.point:hover {
  background: rgba(0, 0, 0, 0.03);
}
.point__number {
  min-width: 24px;
  margin-right: 8px;
  font-weight: 500;
}
.point__text {
  flex: 1;
  cursor: text;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 6px 0;
}
.point__input {
  flex: 1;
  margin-top: 0;
  padding-top: 0;
}
</style>
